import { HOME } from "@/constants/testIds";

const items = [
  { text: "Est. c.1924" },
  { text: "Traceable · Farm to counter" },
  { text: "Family-run · Wiltshire" },
  { text: "Abattoir & Butchery" },
  { text: "Since 1958 · Co. No. 00610856" },
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <section
      data-testid={HOME.marquee}
      className="relative border-y border-[color:var(--hairline)] overflow-hidden bg-[color:var(--paper)]"
    >
      <div className="flex marquee-track py-5 md:py-12 whitespace-nowrap select-none">
        {row.map((it, i) => (
          <div key={`marquee-${i}-${it.text}`} className="flex items-center shrink-0 px-5 md:px-14">
            <span className="font-display italic text-3xl sm:text-4xl md:text-6xl lg:text-7xl leading-none text-[color:var(--ink)]">
              {it.text}
            </span>
            <span className="ml-5 md:ml-14 inline-block w-2 h-2 md:w-3 md:h-3 rounded-full bg-[color:var(--oxblood)]" />
          </div>
        ))}
      </div>
    </section>
  );
}
